module.exports = __webpack_public_path__ + "img/icon-sofortueberweisung.6bba3898.svg";